import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { selector: String }

  connect() {
    this.sync()
  }

  sync(event) {
    const source = event?.target || this.element.querySelector('input[type="checkbox"]')
    if (!source) return

    this.element.querySelectorAll(this.selectorValue).forEach((el) => {
      el.required = source.checked
    })
  }
}
